export default __webpack_public_path__ + "static/media/minus.cf631c93.svg";